<template>
  <NewsletterForm
    v-if="settings"
    :settings="settings.newsletter_settings"
    :widget-id="widgetId"
    @success="openPopup"
  />
  <BasePopup :active="popupVisibility" @close="closePopup">
    <ThanksPopupContent
      v-if="settings"
      :thanks="settings.newsletter_settings.thanks_text"
    />
  </BasePopup>
</template>

<script lang="ts" setup>
import { useWebsiteSettings } from '@/state/websiteSettings'

defineProps<{ widgetId?: string }>()

const settings = await useWebsiteSettings()

const {
  visibility: popupVisibility,
  open: openPopup,
  close: closePopup
} = usePopup()
</script>

<style scoped lang="scss"></style>
